var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "33px",
    viewBox: "0 0 42 33",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.923 4L2.07613 4C0.929845 4 0 3.10435 0 2.00125C0 0.894814 0.929845 0 2.07613 0L29.923 0C31.0693 0 32 0.894814 32 2.00125C32 3.10435 31.0693 4 29.923 4Z",
    transform: "translate(10 27.5)",
    id: "Fill-1",
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.923 4L2.07613 4C0.929845 4 0 3.10519 0 1.99875C0 0.895647 0.929845 0 2.07613 0L29.923 0C31.0693 0 32 0.895647 32 1.99875C32 3.10519 31.0693 4 29.923 4Z",
    transform: "translate(10 14.5)",
    id: "Fill-2",
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.923 4L2.07613 4C0.929845 4 0 3.10435 0 2.00125C0 0.894814 0.929845 0 2.07613 0L29.923 0C31.0693 0 32 0.894814 32 2.00125C32 3.10435 31.0693 4 29.923 4Z",
    transform: "translate(10 1.5)",
    id: "Fill-3",
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3C6 4.65777 4.65849 6 3.00047 6C1.34151 6 0 4.65777 0 3C0 1.34223 1.34151 0 3.00047 0C4.65849 0 6 1.34223 6 3Z",
    transform: "translate(0 0.5)",
    id: "Fill-4",
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3.00047C6 4.65849 4.65849 6 3.00047 6C1.34151 6 0 4.65849 0 3.00047C0 1.34523 1.34151 0 3.00047 0C4.65849 0 6 1.34523 6 3.00047Z",
    transform: "translate(0 13.5)",
    id: "Fill-5",
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3.00047C6 4.65849 4.65849 6 3.00047 6C1.34151 6 0 4.65849 0 3.00047C0 1.34523 1.34151 0 3.00047 0C4.65849 0 6 1.34523 6 3.00047Z",
    transform: "translate(0 26.5)",
    id: "Fill-6",
    fill: "#000000",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuicon);
export default __webpack_public_path__ + "static/media/menuicon.16b2b1a8a99f03c0ff83468c640b004d.svg";
export { ForwardRef as ReactComponent };